/**
 * Re-init product-list carousel controls after product-recommendations AJAX load.
 */
(function () {
  function refreshSection(section) {
    if (!section?.classList?.contains("section-product-recommendations")) return;

    if (typeof window.ProductListSection?.reset === "function") {
      window.ProductListSection.reset(section);
    } else {
      delete section.dataset.productListBound;
    }

    if (typeof window.ProductListSection?.bind === "function") {
      window.ProductListSection.bind(section);
    }

    section.querySelectorAll("peek-carousel").forEach((carousel) => {
      carousel.updateLayout?.();
      const slider = section.querySelector(".product-list__slider");
      if (slider && typeof window.ProductListSection?.bind === "function") {
        window.ProductListSection.bind(section);
      }
    });
  }

  function observeRecommendations(root) {
    (root || document)
      .querySelectorAll(".section-product-recommendations product-recommendations")
      .forEach((el) => {
        if (el.dataset.recommendationsListObserved === "true") return;
        el.dataset.recommendationsListObserved = "true";

        const section = el.closest(".section-product-recommendations");
        if (!section) return;

        const observer = new MutationObserver(() => {
          if (
            el.classList.contains("product-recommendations--loaded") &&
            el.querySelector(".product-list__slider")
          ) {
            refreshSection(section);
          }
        });

        observer.observe(el, {
          childList: true,
          attributes: true,
          attributeFilter: ["class"],
        });

        if (
          el.classList.contains("product-recommendations--loaded") &&
          el.querySelector(".product-list__slider")
        ) {
          refreshSection(section);
        }
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => observeRecommendations());
  } else {
    observeRecommendations();
  }

  document.addEventListener("shopify:section:load", (event) => {
    observeRecommendations(event.target);
  });
})();
